import { render } from "./IconLiveCircle.vue?vue&type=template&id=2cb6f244"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__